import { useCallback } from 'react';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export const useBillingPortal = () => {
  const { apiClient } = useTacticHooks();

  const openBillingPortal = useCallback(async () => {
    try {
      // Only fetch the billing portal URL when this function is called (on-demand)
      // Do NOT use React Query here - we want a fresh URL each time user clicks
      const response = await apiClient.billing.getPortalUrl();
      if (response.result?.url) {
        window.open(response.result.url, '_blank');
        return true;
      }
      return false;
    } catch (error) {
      console.error('Failed to get billing portal URL:', error);
      return false;
    }
  }, [apiClient]);

  return { openBillingPortal };
};
